






















import { Component, Prop, Vue, Emit,Watch } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class BarcodeSetting extends Vue {

    autoCountUp: boolean=false;
    showCompletedVoucher:boolean= false;
    readerEnabled:boolean = false;
    isEnabledOrderInspection: boolean = false;
    cameraEnabled:boolean = false;

    mounted(){        
      this.autoCountUp =  localStorage['autoCountUp'] != 'false'; //初期値はtrue
      this.showCompletedVoucher =  localStorage['showCompletedVoucher'] == 'true'; //初期値はfalse      
      this.readerEnabled =  localStorage['readerEnabled'] != 'false'; //初期値はtrue
      this.isEnabledOrderInspection =  localStorage['isEnabledOrderInspection'] == 'true'; //初期値はfalse

      //毎回初期化する(ライセンスの状況が同じとは限らない)
      navigator.mediaDevices.enumerateDevices().then(devices =>{
        //カメラデバイスがあり検品デバイス数が設定されている場合にカメラゾーンを有効化する
        this.cameraEnabled = devices.filter((device) => device.kind === 'videoinput').length > 0 && this.$api.license.hasScannerLicense;
        this.$nextTick(()=>{
            this.$api.tooltip.mount(this, this.$refs.tooltip_target1 as Element,"バーコード読取時に自動でカウントアップするかどうかを指定します。");         
            this.$api.tooltip.mount(this, this.$refs.tooltip_target2 as Element,"検品済み伝票を表示するかどうかを指定します。");        
            this.$api.tooltip.mount(this, this.$refs.tooltip_target3 as Element,"バーコード読取を背面カメラで行うか外部スキャナで行うかを指定します。");   
            this.$api.tooltip.mount(this, this.$refs.tooltip_target4 as Element,"入出荷検品と受発注検品のどちらを行うかを指定します。"); 
        });        
      });      
                                
    }
  @Watch('readerEnabled')
  public onReaderEnabledChanged() {
    localStorage['readerEnabled'] = this.readerEnabled;
  }
  @Watch('showCompletedVoucher')
  public onShowCompletedVoucherChanged() {
    localStorage['showCompletedVoucher'] = this.showCompletedVoucher;      
  }  
  @Watch('autoCountUp')
  public onAutoCountUpChanged() {
    localStorage['autoCountUp'] = this.autoCountUp;      
  }
  @Watch('isEnabledOrderInspection')
  public onIsEnabledOrderInspectionChanged() {
    localStorage['isEnabledOrderInspection'] = this.isEnabledOrderInspection;
  }
}
